export default{
  common:{
    investigator:'研究者',
    appTitle:'研究简介',
    itemName: '静脉溶栓后轻型脑梗死提前抗血小板治疗的有效性和安全性研究',
    researchFiles:"研究文件",
    protocol:'研究方案',
    protocolPublished:'已发表的 Protocol',
    plan:'统计分析计划书',
    informedConset:'知情同意书',
    dataCommittee:'数据安全委员会',
    steeringCommittee:'研究指导委员会',
    trialSteeringCommittee:'试验指导委员会',
    institutionHumanResearchEthicsCommittee:'伦理委员会',
    dataMonitoringCommittee:'数据监察委员会',
    outcomeCommittee:'结局判读委员会',
    principalInvestigator:'主要研究者简介',
    principalInvestigatorSite:'主要研究单位简介',
    supportPlatform:'项目支持平台',
    introductiontoAssociation:'学会简介',
    ConnectPI:'项目PI联系方式',
    ConnectPM:'项目合作联系方式',
    projectIntroduction:'在研项目简介',
    projectIntroductionInMS:'梅斯合作项目简介',
    recruitingProcess:'入组总进度',
    recruitingSites:'入组中心分布',
    recruitingCases:'累计入组病例数',
    newRecruitingCases:'新增入组病例数',
    cases:'病例数(个)',
    recruitingNumber:'入组人数',
    people:'人',
    sixMonths:'近6个月',
    oneYear:'近1年',
    twoYear:'近2年',
    range:'自定义范围',
    dateStart: '开始日期',
		dateEnd: '结束日期',
    sitesRanking:'中心进度排行及PI简介',
    confirm: '确定',
    showMore:'查看更多',
    viewDetails:'查看详情',
    projectSupportPlatform:'项目支持平台',
    name:'姓名：',
    phone:'电话：',
    email:'邮箱：',
    address:'地址：',
  },
  file:{
    trialSteeringCommittee:[
      {
        name:'吉训明',
        position:'主席',
        organization:'首都医科大学宣武医院'
      },
      {
        name:'陈会生',
        position:'主要研究者',
        organization:'北部战区总医院'
      },
      {
        name:'周中和',
        position:'高级项目管理',
        organization:'北部战区总医院'
      },
      {
        name:'王多劳',
        position:'医学统计师',
        organization:'利物浦热带医学院'
      },
      {
        name:'姜长豪',
        position:'分中心研究者',
        organization:'旅顺口区人民医院'
      },
      {
        name:'刘晓东',
        position:'分中心研究者',
        organization:'通化市血管病医院'
      },
      {
        name:'商秀丽',
        position:'神经内科主任医师',
        organization:'中国医科大学附属第一医院'
      },
      // {
      //   name:'李静',
      //   position:'分中心研究者',
      //   organization:'东港市中心医院'
      // },
    ],
    institutionHumanResearchEthicsCommittee:[
      {
        name:'刘宝军',
        position:'主任委员',
        organization:'北部战区总医院'
      },
      {
        name:'张国旭',
        organization:'北部战区总医院'
      },
      {
        name:'李云慧',
        organization:'北部战区总医院'
      },
      {
        name:'陈巍',
        organization:'北部战区总医院'
      },
      {
        name:'赵海涛',
        organization:'北部战区总医院'
      },
      {
        name:'李毅',
        organization:'北部战区总医院'
      },
      {
        name:'刘欣伟',
        organization:'北部战区总医院'
      },
      {
        name:'祁兴顺',
        organization:'北部战区总医院'
      },
      {
        name:'辛芳冉',
        organization:'北部战区总医院'
      },
      {
        name:'姜东',
        organization:'辽宁和昊律师事务所'
      },
      {
        name:'张丽云',
        organization:'社区代表人员'
      },
    ],
    dataMonitoringCommittee:[
      {
        name:'王伊龙',
        position:'主席',
        organization:'首都医科大学天坛医院'
      },
      {
        name:'杨弋',
        position:'神经内科主任医师',
        organization:'吉林大学附属第一医院'
      },
      {
        name:'陶定波',
        position:'神经内科主任医师',
        organization:'大连医科大学附属第一医院 '
      },
      {
        name:'侯晓雯',
        position:'医学统计师',
        organization:'沈阳医学院'
      },
    ],
    outcomeCommittee:[
      {
        name:'杨弋',
        position:'主席',
        organization:'吉林大学附属第一医院'
      },
      {
        name:'陶定波',
        position:'神经内科主任医师',
        organization:'大连医科大徐附属第一医院'
      },
    ],
    protocolV1Url:'https://static.medsci.cn/product/medsci/pdf/OriginalProtocol-EAST-V1-ch.pdf', 
    protocolV2Url:'https://static.medsci.cn/product/medsci/pdf/OriginalProtocol-EAST-V2-ch.pdf', 
    protocolIJOSUrl:'https://static.medsci.cn/product/medsci/pdf/Protocol-IJOS-EAST-ch.pdf',
    planV1Url:'https://static.medsci.cn/product/medsci/pdf/StatisticalAnalysisPlan-EAST-V1.pdf', 
    planV2Url:'https://static.medsci.cn/product/medsci/pdf/StatisticalAnalysisPlan-EAST-V2.pdf', 
    informedConsetUrl:'https://static.medsci.cn/product/medsci/pdf/informedConsent.pdf',
    principalInvestigator:'陈会生：主任医师，医学博士，博士生导师，北部战区总医院神经内科主任，辽宁省脑血管病临床医学研究中心主任，辽宁省脑卒中质控中心主任。兼任辽宁省脑血管病临床协同创新联盟理事长，中华医学会神经病学分会委员及脑血管病学组委员，中国卒中学会理事。主要研究方向：脑卒中的基础与临床研究。作为项目负责人，共获得国家科技部慢病专项子课题1项，国家卫健委脑防委多中心课题2项，国家自然科学基金5项，辽宁省科技攻关计划5项等；以第一或通讯作者在JAMA、JACC、JAMA Neurology、Nature Communications、Annals of Neurology、JNNP等国际专业期刊发表SCI收录论文100余篇。以第一承担人身份获得辽宁省自然科学二等奖1项，辽宁省医学科技奖二等奖1项。电话：13352452086。Email：chszh@aliyun.com',
    principalInvestigatorSiteContent:'中国人民解放军北部战区总医院作为全军神经医学研究所,其神经内科是辽宁省脑血管病转化医学研究中心,并于2016年牵头成立辽宁省脑血管病临床医学协同创新联盟。',
    
  }
}